import { render, staticRenderFns } from "./BankCashMonthDataComponent.vue?vue&type=template&id=81b72c54&scoped=true"
import script from "./BankCashMonthDataComponent.vue?vue&type=script&lang=js"
export * from "./BankCashMonthDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b72c54",
  null
  
)

export default component.exports